export default __webpack_public_path__ + "static/media/home-1.5da775b1.png";